<template>
    <div class="date-picker">
        <calendar
            class="date-picker-calendar"
            :min-date="minDate"
            :max-date="maxDate"
            :disabled-dates="disabledDates"
            :masks="{ weekdays: 'WWW' }"
            :attributes="attributes"
            locale="en"
            is-expanded
            trim-weeks
            :from-date="selectedDateInstance"
            @dayclick="selectDay"
        />
    </div>
</template>
<script>
import moment from 'moment-timezone';
import Calendar from 'v-calendar/lib/components/calendar.umd';

export default {
    components: {
        Calendar,
    },

    model: {
        event: 'change',
        prop: 'value',
    },

    props: {
        minDate: {
            type: Date,
            default: null,
        },
        maxDate: {
            type: Date,
            default: null,
        },
        value: {
            type: String,
            default: null,
        },
        disabled: {
            default: false,
            type: Boolean,
        },
    },

    computed: {
        /**
         * Returns native Date instance of selected date.
         *
         * @returns {Date|null} Native Date instance of selected date.
         */
        selectedDateInstance() {
            if (this.selectedDate) {
                return moment(this.selectedDate).toDate();
            }

            return null;
        },

        /**
         * Returns list of attributes for days in calendar.
         *
         * @returns {object[]} Attributes for days in calendar.
         */
        attributes() {
            const attributes = [this.todayAttributes];

            if (this.selectedDate) {
                attributes.push({
                    dates: this.selectedDateInstance,
                    highlight: {
                        contentClass: 'active',
                    },
                });
            }

            return attributes;
        },

        todayAttributes: () => ({
            dates: moment().startOf('day').toDate(),
            highlight: {
                class: 'today',
            },
        }),

        selectedDate: {
            /**
             * Gets selected date.
             *
             * @returns {string|null} Selected date.
             */
            get() {
                return this.value;
            },

            /**
             * Sets selected date.
             *
             * @param {string} value Selected date.
             */
            set(value) {
                this.$emit('change', value);
            },
        },

        /**
         * Returns list of dates to disable.
         *
         * Entire calendar is locked when `disabled` prop is set to true.
         *
         * @returns {object|null} Set of dates to disable.
         */
        disabledDates() {
            return this.disabled ? { start: null, end: null } : null;
        },
    },

    methods: {
        /**
         * Sets selected date after clicking day on calendar.
         *
         * @param  {object} day Selected day.
         */
        selectDay(day) {
            if (day.isDisabled) {
                return;
            }

            this.selectedDate = day.id;
        },
    },
};
</script>
